// ActivityTableWithFilters.tsx
import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef, GridSortModel, GridPaginationModel, GridCellParams } from "@mui/x-data-grid";
// import { fetchUsers } from "./fakeServer";
import { User } from "./types";
import { Chip, Link } from "@mui/material";
import { overridePaginationStateWithQueryParams } from "../shared/util/entity-utils/entity-utils";
import { useFetcher, useLocation, useSearchParams } from "react-router-dom";
import { GridSortItem } from "@mui/x-data-grid/models/gridSortModel";
import { profaseDataGridSx } from "./profaseDataGridTheme";

export const ITEMS_PER_PAGE = 15;
export const SORT = 'sort';

export interface ISortBaseState {
    sort: string;
    order: string;
}

export interface IPaginationBaseState extends ISortBaseState {
    itemsPerPage: number;
    activePage: number;
}



const ProfaseDataGrid = (props: any) => {
    const pageLocation = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const rows = props.rows;
    const rowCount = props.rowCount ? props.rowCount : 0;
    const loading = props.loading;




    // const [paginationState, setPaginationState] = useState(
    //     overridePaginationStateWithQueryParams({ pageLocation, ITEMS_PER_PAGE, id: 'id' }, pageLocation.search),
    // );
    const initialPage = Number(searchParams.get("page") ?? 1);  // default 1
    const sortParam = searchParams.get(SORT);
    const defaultSortField = props.defaultSortField ?? 'id';
    const [initialField, initialOrder] = sortParam != null ? sortParam.split(",") : [defaultSortField, 'asc'];

    const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
        page: initialPage - 1,     // DataGrid es 0-indexed
        pageSize: ITEMS_PER_PAGE,
    });

    const [sortItem, setSortItem] = useState<GridSortItem>({ field: initialField, sort: initialOrder === 'asc' ? 'asc' : 'desc' });
    const [sortModel, setSortModel] = useState<GridSortModel>([sortItem]);

    // Initialize active filters from URL params on first render
    // Each param key can appear multiple times → one chip per occurrence
    const [activeFilters, setActiveFilters] = useState<{ field: any; value: string }[]>(() =>
        ((props.filters ?? []) as any[]).flatMap((f: any) => {
            const values = searchParams.getAll(f.name).filter(v => v !== '');
            if (f.single) {
                const v = values.length > 0 ? values[values.length - 1] : null;
                return v != null ? [{ field: f, value: v }] : [];
            }
            return values.map(v => ({ field: f, value: v }));
        })
    );

    const [inputValues, setInputValues] = useState<{ [key: string]: string }>({});

    const clickableColumns = props.filters ?? [];

    useEffect(() => {
        const params = new URLSearchParams(pageLocation.search);
        const pageParam = Number(params.get("page") ?? 1);
        const sortParam = params.get(SORT);

        // 🔹 PAGE
        if (pageParam) {
            const pageNumber = Number(pageParam);
            if (pageParam !== paginationModel.page + 1) {
                setPaginationModel(prev => ({ ...prev, page: pageNumber - 1 }));
            }
        }

        // 🔹 SORT
        if (sortParam) {
            const [field, order] = sortParam.split(",");
            if (sortItem.field !== field || sortItem.sort?.toString() !== order) {
                setSortItem({ field, sort: order === 'asc' ? 'asc' : 'desc' });
            }
        }

        // 🔹 FILTERS — collect all occurrences of each filter param (multi-value)
        const filtersFromUrl = ((props.filters ?? []) as any[]).flatMap((f: any) => {
            const values = params.getAll(f.name).filter(v => v !== '');
            if (f.single) {
                const v = values.length > 0 ? values[values.length - 1] : null;
                return v != null ? [{ field: f, value: v }] : [];
            }
            return values.map(v => ({ field: f, value: v }));
        });
        setActiveFilters(filtersFromUrl);
    }, [pageLocation.search]);

    useEffect(() => {
        console.log('sortModel', [sortModel, sortItem]);
        console.log('sort item changed', [sortModel, sortItem]);
        // setSortModel([sortItem]);
        setSortModel(prev => [
            sortItem     // agrega nuevo
        ]);
    }, [sortItem]);



    useEffect(() => {
        // setPaginationModel({
        //     page: props.page,
        //     pageSize: props.pageSize,
        // });
    }, [rows])

    // useEffect(() => {
    //     console.log('fetchdata', activeFilters);
    //     fetchData(true);
    // }, [activeFilters]);

    useEffect(() => {
        fetchData(false);
    }, [paginationModel, sortModel, activeFilters]);


    const cambiarPagina = (nuevaPagina: any) => {
        searchParams.set("page", (nuevaPagina + 1).toString());
        setSearchParams(searchParams);
    };

    const fetchData = async (reset: boolean) => {

        const sortParam =
            sortModel.length > 0
                ? `${sortModel[0].field},${sortModel[0].sort}`
                : "id,asc";


        const transformedFilters = activeFilters.map((e: any) => ({
            'filterName': e.field.name,
            'filterValue': e.value
        }));

        console.log('FETCH DATA BY PAGE', reset ? 0 : paginationModel.page);
        console.log('FETCH DATA BY SORT', { sortParam });


        await props.fetch({
            page: reset ? 0 : paginationModel.page,
            sort: sortParam,
            filters: transformedFilters,
            size: ITEMS_PER_PAGE
        });

        // Filtrado local (solo demo)
        // const filteredRows = res.content.filter((row) =>
        //     activeFilters.every((f) =>
        //         row[f.field as keyof User]
        //             ?.toString()
        //             .toLowerCase()
        //             .includes(f.value.toLowerCase())
        //     )
        // );

        // setRows(filteredRows);

    };



    // Apply filter: append a new chip (same key can repeat in the URL)
    const handleInputKeyDown = (field: any, e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            e.preventDefault();
            const value = inputValues[field.name]?.trim();
            if (!value) return;

            const params = new URLSearchParams(searchParams);
            // Only add if this exact value isn't already present for this field
            if (!params.getAll(field.name).includes(value)) {
                params.append(field.name, value);
            }
            params.set("page", "1");
            setSearchParams(params);

            setInputValues(prev => ({ ...prev, [field.name]: "" }));
        }
    };

    const handleInputChange = (field: any, value: string) => {
        setInputValues(prev => ({ ...prev, [field.name]: value }));
    };

    const filterChipValueLabel = (field: any, value: string): string => {
        if (field.displayParam) {
            const display = searchParams.get(field.displayParam);
            if (display) return display;
        }
        const opt = (field.options ?? []).find((o: any) => String(o.value) === String(value));
        return opt?.label != null ? String(opt.label) : value;
    };

    // Remove a single chip: delete all values for that key, then re-append the remaining ones
    const handleRemoveFilter = (filter: { field: any; value: string }) => {
        const params = new URLSearchParams(searchParams);
        const remaining = params.getAll(filter.field.name).filter(v => v !== filter.value);
        params.delete(filter.field.name);
        remaining.forEach(v => params.append(filter.field.name, v));
        if (filter.field.displayParam && remaining.length === 0) {
            params.delete(filter.field.displayParam);
        }
        if (remaining.length === 0) {
            (filter.field.clearWith ?? []).forEach((name: string) => params.delete(name));
        }
        params.set("page", "1");
        setSearchParams(params);
    };

    const handleClearAllFilters = () => {
        const params = new URLSearchParams(searchParams);
        ((props.filters ?? []) as any[]).forEach((f: any) => {
            params.delete(f.name);
            if (f.displayParam) {
                params.delete(f.displayParam);
            }
        });
        Object.entries((props.clearFiltersSetParams ?? {}) as Record<string, string>).forEach(([key, value]) => {
            params.set(key, value);
        });
        params.set("page", "1");
        setSearchParams(params);
    };

    // Columnas con renderCell dinámico
    //field.charAt(0).toUpperCase() + field.slice(1)
    const columns: GridColDef[] = [
        ...props.cols.map((column: any) => ({
            field: column.field,
            headerName: column.headerName + '',
            flex: column.flex,
            width: column.width,
            filterable: false,
            renderCell: (params: GridCellParams) => {
                return <div className="profase-datagrid-cell-wrap">{column.renderCell ? column.renderCell(params) : params.value?.toString()}</div>
            }
        }))


        // <Link
        //     component="button"
        //     variant="body2"
        //     onClick={() => { }}
        // // onClick={() => handleCellFilter(column.name, params.value?.toString() || "")}
        // >

        // </Link>

    ];

    // const updateSearchParams = (
    //     paginationModel: GridPaginationModel,
    //     sortModel: GridSortItem
    // ) => {
    //     const params: any = {
    //         page: String(paginationModel.page + 1),
    //     };
    //     if (sortItem != null) {
    //         params.sort = `${sortItem.field},${sortItem.sort}`;
    //     }
    //     console.log('update seach params ', params);
    //     setSearchParams(params);
    // };
    const handlePaginationChange = (newModel: GridPaginationModel) => {
        console.log('update page', [paginationModel.page, newModel.page + 1]);
        const params = new URLSearchParams(searchParams); // clonar
        params.set("page", String(newModel.page + 1));           // actualizar solo page
        setSearchParams(params);
        // setPaginationModel(newModel);
    };
    const handleSortChange = (newModel: GridSortModel) => {
        console.log('sort change ', newModel);
        const sortItem = { field: newModel.length > 0 ? newModel[0].field : (props.defaultSortField ?? 'id'), sort: newModel.length > 0 ? newModel[0].sort : 'asc' }
        const params = new URLSearchParams(searchParams); // clonar
        params.set("sort", `${sortItem.field},${sortItem.sort}`);           // actualizar solo page
        setSearchParams(params);
        // setSortItem(prev => ({ ...prev, field: sortItem.field, sort: sortItem.sort }));
    }

    // Find the filter definition that corresponds to a column (match by field name or header label)
    const getColumnFilter = (column: any): any | undefined =>
        clickableColumns.find(
            (f: any) =>
                f.name === column.field ||
                (f.label != null &&
                    column.headerName != null &&
                    String(f.label).toLowerCase() === String(column.headerName).toLowerCase()),
        );

    // Build columns with inline header filter inputs for filterable columns
    const columnsWithHeaderFilters: GridColDef[] = props.cols.map((column: any) => {
        const filter = column.filterable === false ? undefined : getColumnFilter(column);
        const customHeader = column.renderHeader;
        return {
            field: column.field,
            headerName: column.headerName + '',
            flex: column.flex,
            width: column.width,
            filterable: false,
            sortable: column.sortable !== false && !!column.field,
            cellClassName: column.cellClassName,
            headerClassName: column.headerClassName,
            renderHeader: customHeader
                ? () => (
                    <div onClick={e => e.stopPropagation()}>
                        {customHeader()}
                    </div>
                )
                : filter
                ? () => (
                    <div
                        style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 4, padding: '4px 0' }}
                        onClick={e => e.stopPropagation()}
                    >
                        <span className="profase-datagrid-header-label">
                            {column.headerName}
                        </span>
                        {filter.type === 'select' ? (
                            <select
                                value={filter.single ? (searchParams.get(filter.name) ?? '') : ''}
                                onChange={e => {
                                    const value = e.target.value;
                                    const params = new URLSearchParams(searchParams);
                                    if (filter.single) {
                                        params.delete(filter.name);
                                        if (value) {
                                            params.set(filter.name, value);
                                        }
                                    } else {
                                        if (!value) return;
                                        if (!params.getAll(filter.name).includes(value)) {
                                            params.append(filter.name, value);
                                        }
                                    }
                                    params.set('page', '1');
                                    setSearchParams(params);
                                    if (!filter.single) {
                                        e.target.value = '';
                                    }
                                }}
                                onClick={e => e.stopPropagation()}
                                className="profase-datagrid-filter-control"
                                style={{ cursor: 'pointer' }}
                            >
                                <option value="">— Seleccionar —</option>
                                {(filter.options ?? []).map((opt: any) => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                        ) : (
                            <input
                                type="text"
                                placeholder={`Filtrar…`}
                                value={inputValues[filter.name] || ''}
                                onChange={e => handleInputChange(filter, e.target.value)}
                                onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                                    e.stopPropagation();
                                    handleInputKeyDown(filter, e);
                                }}
                                onClick={e => e.stopPropagation()}
                                autoComplete="off"
                                className="profase-datagrid-filter-control"
                            />
                        )}
                    </div>
                )
                : undefined,
            renderCell: (params: GridCellParams) => (
                <div className="profase-datagrid-cell-wrap">
                    {column.renderCell ? column.renderCell(params) : params.value?.toString()}
                </div>
            ),
        };
    });

    return (
        <div style={{ width: "100%" }}>
            {activeFilters.length > 0 && (
                <div className="profase-datagrid-filter-banner" role="status">
                    <span>Calculado con filtros. ¿Desea ver toda la información?</span>
                    <button
                        type="button"
                        className="profase-datagrid-clear-filters"
                        onClick={handleClearAllFilters}
                    >
                        Mostrar todo
                    </button>
                </div>
            )}

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10, flexWrap: 'wrap', gap: 8 }}>
                <h3 className="profase-datagrid-title">{props.title}</h3>

                {/* Active filter chips */}
                {activeFilters.length > 0 && (
                    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
                        {activeFilters.map((f: any) => (
                            <Chip
                                key={`${f.field.name}:${f.value}`}
                                label={`${f.field.label}: ${filterChipValueLabel(f.field, f.value)}`}
                                onDelete={() => handleRemoveFilter(f)}
                                color="primary"
                                size="small"
                            />
                        ))}
                    </div>
                )}
            </div>

            <DataGrid
                rows={rows}
                columns={columnsWithHeaderFilters}
                autoHeight={props.gridHeight == null}
                pagination
                paginationMode="server"
                disableRowSelectionOnClick
                disableColumnMenu
                columnHeaderHeight={props.columnHeaderHeight ?? 96}
                columnGroupHeaderHeight={props.columnGroupHeaderHeight ?? 44}
                columnGroupingModel={props.columnGroupingModel}
                localeText={{ noRowsLabel: 'Sin Registro' }}
                paginationModel={paginationModel}
                onPaginationModelChange={handlePaginationChange}
                onSortModelChange={(newModel) => { handleSortChange(newModel); }}
                rowCount={rowCount}
                sortingMode="server"
                sortModel={sortModel}
                loading={loading}
                getRowId={props.getRowId}
                getRowClassName={props.getRowClassName}
                sx={{
                    ...(props.gridHeight != null ? { height: props.gridHeight } : {}),
                    ...profaseDataGridSx,
                    '& .MuiDataGrid-columnHeader': {
                        alignItems: 'flex-start',
                        paddingTop: '8px',
                        paddingBottom: '8px',
                        overflow: 'visible',
                        backgroundColor: 'var(--crm-grid-header-bg)',
                        color: 'var(--crm-grid-header-text)',
                    },
                    '& .MuiDataGrid-columnHeaderTitleContainer': {
                        alignItems: 'flex-start',
                        overflow: 'visible',
                        whiteSpace: 'normal',
                    },
                    '& .MuiDataGrid-columnHeaderTitleContainerContent': {
                        overflow: 'visible',
                        alignItems: 'stretch',
                        alignSelf: 'stretch',
                        minWidth: 0,
                        width: '100%',
                    },
                    ...props.sx,
                }}
            />
        </div>
    );
};

export default ProfaseDataGrid;
